module.exports = __webpack_public_path__ + "videos/stroke-long.3ee1d44.mp4";